<script lang="ts">
    import { Col,Alert} from "sveltestrap";
    import { AlertIconInverseMessage, AlertWithIconinverse } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Alert/Alert.json"
</script>
<Col sm="12" xl="6">
    <Card cardHeader2props="pb-0">
      <div slot="customHeader2">
        <h5>{AlertWithIconinverse}</h5>
        <span>{@html AlertIconInverseMessage}</span>
      </div>
      <div slot="contentbody">
        <Alert dismissible color="primary" class="inverse">
            <i class="icon-timer"></i>
            <p>Your time Over after <b>5</b> miniute</p>
        </Alert>
        {#each data.AlertWithIconinversedata as alertItem}
          <Alert dismissible color={alertItem.color} class="inverse">
              <i class={`${alertItem.icon} ${alertItem.class}`} ></i>
              <p>{alertItem.title}</p>
          </Alert>
        {/each}
      </div>
    </Card>
</Col>